export default function FilmGrain() {
  return <div className="film-grain" aria-hidden="true" />
}
